import { render, staticRenderFns } from "./EventApplyModal.vue?vue&type=template&id=2be913d2&scoped=true"
import script from "./EventApplyModal.vue?vue&type=script&lang=js"
export * from "./EventApplyModal.vue?vue&type=script&lang=js"
import style0 from "./EventApplyModal.vue?vue&type=style&index=0&id=2be913d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be913d2",
  null
  
)

export default component.exports